const ACCOUNT_HASH = process.env.NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH;

/** Cloudflare Images' delivery host; `EX-HAL01`'s test page tries it when this build names images there. */
export const CLOUDFLARE_IMAGE_HOST = "imagedelivery.net";

export function cloudflareImageHost(): string | null {
  return ACCOUNT_HASH ? CLOUDFLARE_IMAGE_HOST : null;
}

export type CfImageVariant =
  | "thumb"
  | "thumbnail"
  | "card"
  | "hero"
  | "avatar"
  | "public"
  | "og";

/**
 * Constructs a Cloudflare Images delivery URL.
 * Returns empty string when ACCOUNT_HASH is not configured (graceful degradation).
 *
 * Variants match the canonical Cloudflare Images variants in docs/09_MEDIA_STRATEGY.md.
 */
export function cfImageUrl(
  imageId: string,
  variant: CfImageVariant = "card",
): string {
  if (!ACCOUNT_HASH || !imageId) return "";
  return `https://${CLOUDFLARE_IMAGE_HOST}/${ACCOUNT_HASH}/${imageId}/${variant}`;
}
